import { c as _c } from "react/compiler-runtime";
import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
export const useDefaultDndSensors = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      activationConstraint: {
        distance: 8
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSensors(useSensor(PointerSensor, t0));
};